import { assertValidVersion } from "@tsparticles/engine";
import { SquareDrawer } from "./SquareDrawer.js";
export async function loadSquareShape(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addShape(new SquareDrawer(), refresh);
}
